<div class="receiving-report-shipment-form">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loadingCurrentReceivingReport$ | async"
    [classes]="'loading'"
  ></div>

  <h2 mat-dialog-title>
    Receiving Report

    <button mat-dialog-close aria-label="Close dialog" class="close">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content #scrollingContainer [formGroup]="form">
    <cdk-virtual-scroll-viewport
      itemSize="81"
      style="height: 630px; overflow-y: auto"
      [scrollingElement]="scrollingContainer"
      [minBufferPx]="405"
      [maxBufferPx]="810"
    >
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label class="lum-label">Received Date</label>
            <input class="lum-input" formControlName="receivedDate" type="date" />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label class="lum-label">Tracking Number</label>
            <input class="lum-input" type="text" formControlName="trackingNumber" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label class="lum-label">Received By</label>
            <input
              class="lum-input"
              formControlName="receivedBy"
              type="text"
              [ngClass]="{
                error: receivedByControl?.invalid,
              }"
            />
            <mat-error *ngIf="receivedByControl && receivedByControl.invalid">
              <small>
                {{ receivedByControl | validateField }}
              </small>
            </mat-error>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label class="lum-label">Received At</label>
            <input
              class="lum-input"
              formControlName="receivedAt"
              type="text"
              [ngClass]="{
                error: receivedAtControl?.invalid,
              }"
            />
            <mat-error *ngIf="receivedAtControl && receivedAtControl.invalid">
              <small>
                {{ receivedAtControl | validateField }}
              </small>
            </mat-error>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label class="lum-label">Alternate IDs</label>
            <lum-alternate-ids
              [formArray]="alternateIdsFormArray"
              [label]="'Alternate IDs'"
              [placeholder]="'Press enter to add alternate id...'"
            ></lum-alternate-ids>
          </div>
        </div>
      </div>

      <hr />

      <div>
        <div class="flex justify-content-between">
          <div>
            <ng-container>
              <div class="flex gap-4">
                <div class="w-50">
                  <label class="lum-label">Filter By Type</label>
                  <mat-select
                    class="lum-select"
                    [value]="currentSearchFilter"
                    (selectionChange)="onFilterByChange($event)"
                  >
                    <mat-option [value]="recevingReportFilterBy.PURCHASE_ORDER_ID"
                      >Purchase Order #</mat-option
                    >
                    <mat-option
                      [value]="recevingReportFilterBy.SHIPMENT_REFERENCE_NUMBER"
                      >Shipment Reference #</mat-option
                    >
                    <!-- <mat-option [value]="recevingReportFilterBy.SKU"
                      >SKU</mat-option
                    >
                    <mat-option [value]="recevingReportFilterBy.ALTERNATIVE_SKU"
                      >Alternative SKU</mat-option
                    > -->
                  </mat-select>
                </div>
                <div class="w-50">
                  <div class="lum-label">Filter by Supplier</div>
                  <lum-ui-autocomplete
                    [placeholder]="'Search supplier'"
                    [options]="suppliers"
                    [debounceTime]="500"
                    [loading]="loadingSupplier"
                    [displayProperty]="'factory_name'"
                    [control]="supplierControl"
                    [value]="supplierIdDisplayValue"
                    (inputChangeEvent)="onSearchSupplierChange($event)"
                    (optionSelectedEvent)="onSelectSupplier($event)"
                  ></lum-ui-autocomplete>
                </div>
                <div class="w-80">
                  <label class="lum-label">
                    Search
                    <span *ngIf="loadingReceivableOrders$ | async">
                      <i class="fas fa-spinner fa-spin"></i>
                    </span>
                  </label>
                  <lum-ui-autocomplete
                    [options]="receivableOrders"
                    [debounceTime]="1000"
                    [loading]="loadingReceivableOrders$ | async"
                    [displayProperty]="'label'"
                    (inputChangeEvent)="onSearch($event)"
                    (optionSelectedEvent)="onSelectReceivableOrder($event)"
                    class="input-box"
                  ></lum-ui-autocomplete>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="flex gap-4">
            <div
              *ngIf="
                'red_feature_DV-1888_supplier_purchase_order_item_list'
                  | featureFlag
              "
              class="w-55"
            >
              <label class="lum-label">Bulk Update Warehouse </label>
              <lum-warehouse-search-dropdown
                [selected]="form.get('bulkWarehouse').value"
                (selectItemEvent)="onSelectBulkUpdateWarehouse($event)"
              ></lum-warehouse-search-dropdown>
            </div>
            <div class="w-55">
              <label class="lum-label">Bulk Update Location </label>
              <lum-warehouse-search-dropdown
                [selected]="form.get('bulkLocation')?.value"
                [warehouseId]="form.get('bulkWarehouse').value?.id || null"
                (selectItemEvent)="onSelectBulkUpdateLocation($event)"
                [disabled]="form.get('bulkLocation').disabled"
              ></lum-warehouse-search-dropdown>
            </div>
          </div>
        </div>

        <hr class="mt-8" />
        <div class="mt-8">
          <h5>Items</h5>
        </div>

        <ng-container *ngIf="shipmentItemsFormArray.controls?.length; else empty">
          <table class="lum-table lum-table--classic">
            <thead>
              <tr>
                <th>PO #</th>
                <th>SKU</th>
                <th>Product Name</th>
                <th>Warehouse</th>
                <th>Location</th>
                <th>Lot</th>
                <th>Qty</th>
                <th>Unit</th>
                <th *ngxPermissionsOnly="['skuUnitCost.read']">Unit Price</th>
                <th>Tags</th>
                <th *ngxPermissionsOnly="['skuUnitCost.read']">Line Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody formArrayName="shipmentItems">
              <ng-container
                *ngFor="
                  let shipmentItem of shipmentItemsFormArray.controls;
                  let i = index;
                  trackBy: trackByControlValue
                "
              >
                <!-- TODO: Table danger styling reach out to nique -->
                <tr [formGroupName]="i">
                  <td>{{ shipmentItem.value?.supplierPurchaseOrderId }}</td>
                  <td>{{ shipmentItem.value?.sku }}</td>
                  <td>{{ shipmentItem.value?.productName }}</td>
                  <td>
                    <lum-warehouse-search-dropdown
                      [selected]="shipmentItem.value?.warehouse"
                      (selectItemEvent)="onSelectWarehouse($event, i)"
                    ></lum-warehouse-search-dropdown>
                  </td>
                  <td>
                    <lum-warehouse-search-dropdown
                      [warehouseId]="shipmentItem.value?.warehouse?.id || null"
                      [selected]="shipmentItem?.value?.location"
                      (selectItemEvent)="onSelectLocation($event, i)"
                    ></lum-warehouse-search-dropdown>
                  </td>
                  <td>
                    <ng-container
                      *ngIf="
                        shipmentItem.value?.lotTracking
                          | receivingReportEnableBinAndLotTracking
                            : ftLocationBins
                            : ftLotTracking
                      "
                    >
                      <input
                        (focus)="onLoadLots(shipmentItem.value)"
                        (debounceValue)="onSearchLot($event, shipmentItem.value)"
                        [matAutocomplete]="autoSearchLot"
                        [debounceTime]="1000"
                        [disabled]="loadingLocations$ | async"
                        lumDebounceTime
                        type="text"
                        class="lum-input"
                        formControlName="lot"
                      />
                      <mat-autocomplete
                        [displayWith]="displayFnLot"
                        #autoSearchLot="matAutocomplete"
                      >
                        <mat-option
                          disabled
                          class="loading"
                          *ngIf="loadingLocations$ | async; else lots"
                        >
                          <mat-spinner diameter="25"></mat-spinner>
                        </mat-option>

                        <ng-template #lots>
                          <mat-option
                            *ngFor="
                              let lot of lots$ | async;
                              trackBy: trackByControlValue
                            "
                            [value]="lot"
                          >
                            {{ lot?.lot_number }}
                          </mat-option>

                          <mat-divider></mat-divider>
                          <mat-option
                            (click)="onOpenCreateLotForm(shipmentItem.value, i)"
                          >
                            Create Lot
                          </mat-option>
                        </ng-template>
                      </mat-autocomplete>
                    </ng-container>
                  </td>
                  <td>
                    <input
                      formControlName="quantity"
                      type="number"
                      class="lum-input text-right"
                      lumDecimalLimit
                    />
                  </td>
                  <td>{{ shipmentItem.value?.unitOfMeasure }}</td>
                  <td *ngxPermissionsOnly="['skuUnitCost.read']">
                    <input
                      formControlName="unitPrice"
                      type="number"
                      class="lum-input text-right"
                      [ngClass]="{
                        error: shipmentItem.get('unitPrice')?.invalid,
                      }"
                    />
                  </td>
                  <td>
                    <lum-tag-autocomplete-chip
                      [formArray]="shipmentItem.controls.tagIds"
                    ></lum-tag-autocomplete-chip>
                  </td>
                  <td *ngxPermissionsOnly="['skuUnitCost.read']">
                    {{
                      shipmentItem.value?.quantity * shipmentItem.value?.unitPrice
                        | lumCurrency
                    }}
                  </td>
                  <td>
                    <button
                      *ngIf="!currentReceivingReportId"
                      mat-icon-button
                      color="warn"
                      (click)="onRemoveItem(shipmentItem.value?.id)"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
              </ng-container>
              <tr>
                <td colspan="6"></td>
                <td colspan="3" class="text-right">
                  <b>Total Units: {{ totalItemUnits | decimalPlaces }}</b>
                </td>
                <td
                  *ngxPermissionsOnly="['skuUnitCost.read']"
                  colspan="4"
                  class="text-right"
                >
                  <b>Total Cost: {{ totalItemCost | lumCurrency }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </div>

      <hr class="mt-8" />
      <div class="mt-8">
        <h5>Extra Costs</h5>
        <lum-purchase-order-shipment-extra-cost-table
          [parentForm]="form"
          [mode]="'create'"
        ></lum-purchase-order-shipment-extra-cost-table>
      </div>
      <hr class="mt-8" />
      <div *ngxPermissionsOnly="['skuUnitCost.read']" class="text-right text-large">
        <b>Overall Total: {{ overAllTotalCost | lumCurrency }}</b>
      </div>
    </cdk-virtual-scroll-viewport>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      type="button"
      class="lum-button lum-button--secondary mr-2"
      mat-button
      mat-dialog-close
    >
      Cancel
    </button>
    <lum-ui-button
      label="Submit"
      [loading]="submitting$ | async"
      [disabled]="form.invalid || !shipmentItemsFormArray.controls?.length"
      (click)="onSubmit()"
    ></lum-ui-button>
  </mat-dialog-actions>
</div>

<ng-template #empty>
  <lum-ui-empty-page
    class="mt-8"
    title="There are no shipment items to display"
  ></lum-ui-empty-page>
</ng-template>
